<template>
  <el-select class="select-default country-autcomplete"
             :name="name"
             :placeholder="$t('generic.country')"
             filterable
             clearable
             :value="value"
             v-bind="$attrs"
             v-on="listeners">
    <template v-slot:prefix>
      <img v-if="value"
           :src="`/static/img/countries/${value}.svg`"
           :alt="value"
           class="w-5 h-5"
      >
    </template>
    <i slot="prefix" class="nc-icon nc-globe-2"></i>
    <el-option class="select-default"
               v-for="country in countryOptions"
               :key="country.value"
               :label="country.label"
               :value="country.value">
      <div class="flex items-center">
        <img :src="`/static/img/countries/${country.value}.svg`"
             :alt="country.label"
             class="w-6 h-6"
        >
        <span class="ml-1">{{country.label}}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { countryOptions } from 'src/utils/countries'
import { Select, Option } from 'element-ui'

export default {
  name: 'country-flag-select',
  inheritAttrs: false,
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    name: String,
    value: String,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      countryOptions
    }
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        change: this.onChange
      }
    },
  },
  methods: {
    onChange (val) {
      this.$emit('change', val)
      this.findCountryByCode(val)
    },
    findCountryByCode (code) {
      let country = this.countryOptions.find(c => c.value === code)
      if (!country) {
        return
      }
      this.$emit('country-change', country)
    },
  }
}
</script>

<style lang="scss">
.country-autcomplete {
  width: 100%;

  .el-input__prefix {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
